import React from "react";
import Office from "./Office";

const MattPic = "./img/matt3.jpg";

const About = () => {
    return (
        <React.Fragment>
            <section id="bio">
                <div className="container mx-auto mb-4 flex px-10 py-5 md:flex-row flex-col items-center">
                    <div className="font-body lg:flex-grow md:w-1/2 lg:pr-36 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
                        <h1 className="font-title sm:text-4xl text-3xl mb-4 font-medium">
                            About Me
                        </h1>
                        <p className="mb-8 leading-relaxed">
                            I am a Lecturer in the Department of Mathematics at the University of Georgia. I enjoy spending time with my family, running, playing music, duplicate bridge, and helping others find joy in math.
                            My mathematical research interests include problems in analytic and enumerative combinatorics, as well as analytic number theory. 
                        </p>

                        <h2 className="mb-2">{"Email: "}
                            <a href='mailto:justmatt@uga.edu' title='email' className="hover:text-highlight">justmatt@uga.edu</a>
                        </h2>
                        <h2 className="mb-2">{"Office: "}
                            <a
                                href='https://www.google.com/maps/place/200+D.+W.+Brooks+Drive,+Athens,+GA+30602/@33.9460446,-83.3840311,15z/data=!3m1!4b1!4m5!3m4!1s0x88f66cfefe1188bb:0x8dc7c8bdb67d8975!8m2!3d33.9460449!4d-83.3752763?hl=en'
                                target="_blank"
                                title='office'
                                className="hover:text-highlight"
                            >
                                Boyd 649-B
                            </a>
                        </h2>
                        <a
                            className="mt-2 hover:text-highlight underline"
                            href="https://drive.google.com/file/d/1gA-JAPbIVNu8ad5EI-qqp-GA_ATINhG6/view?usp=sharing"
                            target="_blank"
                            title="cv">
                            Curriculum Vitae
                        </a>
                    </div>
                    <div className="w-1/4 md:w-1/3">
                        <img
                            className="object-cover object-center rounded-full"
                            alt="hero"
                            src={MattPic}
                        />
                    </div>
                </div>
            </section>
            <Office />
        </React.Fragment>
    );
}
export default About;


// WEBPACK FOOTER //
// ./src/components/About.jsx